import { render, staticRenderFns } from "./assignBranch.vue?vue&type=template&id=ede330d2"
import script from "./assignBranch.vue?vue&type=script&lang=js"
export * from "./assignBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports